import { render, staticRenderFns } from "./ClientPage-FullPage.vue?vue&type=template&id=64024d2a&"
import script from "./ClientPage-FullPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage-FullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports